import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';

//reducers
import dataReducer from './data';
import viewReducer from './view';
import idReducer from './id';
import storeReducer from './cart';
import lastReducer from './last';
import searchReducer from './search';
import paramsReducer from './params';
import authReducer from './auth';
import langReducer from './lang';
import modalReducer from './modal';
import accordionReducer from './accordion';
import orderReducer from './order';
import barReducer from './bar';

const reducers = combineReducers({
  data: dataReducer,
  view: viewReducer,
  id: idReducer,
  cart: storeReducer,
  last: lastReducer,
  search: searchReducer,
  params: paramsReducer,
  auth: authReducer,
  lang: langReducer,
  modal: modalReducer,
  accordion: accordionReducer,
  order: orderReducer,
  bar: barReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['lang', 'data', 'last', 'cart', 'params', 'auth'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

export default store;